// axios 使用的动态地址
const currentUrl = window.location.href;
var pos = window.location.pathname
window.baseUrl = currentUrl.substring(0, currentUrl.indexOf(pos))
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    config: null,
    loading: false,
    inWX: false,
    giftbtn: true,
    IOS: false,
    Android: false,
    showVideo:false,
    webSocketMsg: {}
  },
  mutations: {
    // socketMsg
    web_socket_msg (state, status) {
      state.webSocketMsg = status
    },
    setConfig(state, data) {
      state.config = data;
    },
    setLoading(state, data) {
      state.loading = data;
    },
    setInWx(state, data) {
      state.inWX = data;
    },
    setGiftBtn(state, data) {
      state.giftbtn = data
    },
    setInIOS(state, data) {
      state.IOS = data
    },
    setInAndroid(state, data) {
      state.Android = data
    }
  },
  actions: {},
  modules: {},
});
